import { useTrackEvent } from './useTrackEvent'

export function useTrackPageView(pageTitle: string) {
  useTrackEvent('Page Viewed', { 'Page Title': pageTitle })
}
